import React from "react";
import {Button, Table} from "react-bootstrap";
import {ToolTip} from "../ProPlans/PlanCards";
import {formatNumber} from "../../utils/general";
import {PLANS} from "../../constants/plans";

const getPrice = (period, price) => (period === 'yearly' ? price / 12 : price);

function PricingTable({ plans, period, featureList }) {
  const price_free = plans.FREE.prices[period].value;
  const price_tiny = plans.TINY.prices[period].value;
  const price_solo = plans.PRO.prices[period].value;
  const price_pro = plans.PRO_U.prices[period].value;
  return (
    <><Table className="mt-5" responsive hover>
      <thead>
        <tr>
          <th className="font-20 bold text-start d-none d-sm-block">
            Plans <span className="d-block">&nbsp;</span>
          </th>
          <th className="font-20 bold text-start">
            <span>Free</span>
            <span className="d-block">${getPrice(period, price_free)}/mo</span>
          </th>
          <th className="text-blue font-20 bold text-start">
            Tiny <span className="d-block">${getPrice(period, price_tiny)}/mo</span>
          </th>
          <th className="text-purple font-20 bold text-start">
            Solo <span className="d-block">${getPrice(period, price_solo)}/mo</span>
          </th>
          <th className="text-warning font-20 bold text-start">
            Pro <span className="d-block">${getPrice(period, price_pro)}/mo</span>
          </th>
          <th className="text-secondary font-20 bold text-start">
            Business <span className="d-block">~ /mo</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <>
          <tr className="d-block d-sm-none w-100 border border-0">
            <td className="text-start bold font-18 border border-0" colSpan={4}>
              Active Sites
            </td>
          </tr>
          <tr>
            <td className="text-start bold font-18 d-none d-sm-block">Active Projects <ToolTip text="abc.tiiny.site is one active project, multiple files can be uploaded on one active project" /></td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/free.svg`} />
              <span className="d-inline-block font-18">{plans.FREE.projectLimit}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tiny.svg`} />
              <span className="d-inline-block font-18">{plans.TINY.projectLimit}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/solo.svg`} />
              <span className="d-inline-block font-18">{plans.PRO.projectLimit}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/pro.svg`} />
              <span className="d-inline-block font-18">{plans.PRO_U.projectLimit}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tick-business.svg`} />
              <span className="d-inline-block font-18">custom</span>
            </td>
          </tr>
        </>
        <>
          <tr className="d-block d-sm-none w-100 border border-0">
            <td className="text-start bold font-18 d-block d-sm-none w-100 border border-0" colSpan={4}>
              File Uploads
            </td>
          </tr>
          <tr>
            <td className="text-start bold font-18 d-none d-sm-block">File Uploads <ToolTip text="Limit per file upload, per site" /></td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/free.svg`} />
              <span className="d-inline-block font-18">{plans.FREE.fileSizeLimit} mb</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tiny.svg`} />
              <span className="d-inline-block font-18">{plans.TINY.fileSizeLimit} mb</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/solo.svg`} />
              <span className="d-inline-block font-18">{plans.PRO.fileSizeLimit} mb</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/pro.svg`} />
              <span className="d-inline-block font-18">{plans.PRO_U.fileSizeLimit} mb</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tick-business.svg`} />
              <span className="d-inline-block font-18">custom mb</span>
            </td>
          </tr>
        </>
        <>
          <tr className="d-block d-sm-none w-100 border border-0">
            <td className="text-start bold font-18 d-block d-sm-none w-100 border border-0" colSpan={4}>
              Visitors <span className="font-small">/mo</span>
            </td>
          </tr>
          <tr>
            <td className="text-start bold font-18 d-none d-sm-block">Visitors <span className="font-small">/mo</span><ToolTip text="Limit per month, per account" /></td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/free.svg`} />
              <span className="d-inline-block font-18">{formatNumber(plans.FREE.visitorLimit)}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tiny.svg`} />
              <span className="d-inline-block font-18">{formatNumber(plans.TINY.visitorLimit)}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/solo.svg`} />
              <span className="d-inline-block font-18">{formatNumber(plans.PRO.visitorLimit)}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/pro.svg`} />
              <span className="d-inline-block font-18">{formatNumber(plans.PRO_U.visitorLimit)}</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src={`/assets/icons/tick-business.svg`} />
              <span className="d-inline-block font-18">custom</span>
            </td>
          </tr>
        </>
        <>
          <tr className="d-block d-sm-none w-100 border border-0">
            <td className="text-start bold font-18 d-block d-sm-none w-100 border border-0" colSpan={4}>
              Bandwidth <span className="font-small">/mo</span>
            </td>
          </tr>
          <tr>
            <td className="text-start bold font-18 d-none d-sm-block">Bandwidth <span className="font-small">/mo</span><ToolTip text="Limit Per month, per account" /></td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src="/assets/icons/free.svg" />
              <span className="d-inline-block font-18">{plans.FREE.bandwidthLimit} GB</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src="/assets/icons/tiny.svg" />
              <span className="d-inline-block font-18">{plans.TINY.bandwidthLimit} GB</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src="/assets/icons/solo.svg" />
              <span className="d-inline-block font-18">{plans.PRO.bandwidthLimit} GB</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src="/assets/icons/pro.svg" />
              <span className="d-inline-block font-18 ms-2">{plans.PRO_U.bandwidthLimit} GB</span>
            </td>
            <td className="text-start">
              <img className="d-inline-block me-2" height="22px" width="22px" alt="check" src="/assets/icons/tick-business.svg" />
              <span className="d-inline-block font-18">custom GB</span>
            </td>
          </tr>
        </>
        {featureList.map(({ label, tooltip, enabled }, index) => (
          <>
            <tr className="d-block d-sm-none w-100 border border-0">
              <td className="text-start bold font-18 d-block d-sm-none border border-0" colSpan={4}>
                  {label}
              </td>
            </tr>
            <tr key={index}>
              <td className="text-start bold font-18 d-none d-sm-block">
                  {label} <ToolTip text={tooltip} />
              </td>
              <td className="text-start">
                {enabled.includes(PLANS.FREE.id) && (
                  <img className="d-block" height="22px" width="22px" alt="check" src="/assets/icons/free.svg" />
                )}
              </td>
              <td className="text-start">
                {enabled.includes(PLANS.TINY.id) && (
                  <img className="d-block" height="22px" width="22px" alt="check" src="/assets/icons/tiny.svg" />
                )}
              </td>
              <td className="text-start">
                {enabled.includes(PLANS.PRO.id) && (
                  <img className="d-block" height="22px" width="22px" alt="check" src="/assets/icons/solo.svg" />
                )}
              </td>
              <td className="text-start">
                {enabled && (
                  <img className="d-block" height="22px" width="22px" alt="check" src="/assets/icons/pro.svg" />
                )}
              </td>
              <td className="text-start">
                {enabled && (
                  <img className="d-block" height="22px" width="22px" alt="check" src="/assets/icons/tick-business.svg" />
                )}
              </td>
            </tr>
          </>
        ))}
      </tbody>
    </Table>
      <Button
        className="ms-auto"
        variant="outline-secondary"
        style={{width: 150}}
        onClick={() => window.$crisp.push(['do', 'chat:open'])}
      >
        Contact us
      </Button>
    </>
  );
}

export default PricingTable;
